// // App.jsx 

import React from 'react';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import './styles.css'; 
import './index.css'; 
import './App.css'; 
import Navbar from './Navbar';
import Home from './Home';
import Projects from './Projects'; 
import About from './About';  
// import ProducerCredits from './ProducerCredits'; 


const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} /> 
        <Route path="/about" element={<About />} /> 
        {/* <Route path="/producer-credits" element={<ProducerCredits />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;



